import { Select } from 'antd';
import styled from 'styled-components';

export const AntSelect = styled(Select)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ProjectOptionContent = styled.div`
  & > span.file-name {
    word-break: break-word;
    font-weight: 700;
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    display: inline-block;
    width: 99%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > div {
    font-weight: 400;
    & > span.structure {
      word-break: break-word;
      font-size: 0.75rem;
      color: ${({ theme }) => theme.colors.grayStatus};
    }

    & > span.revision {
      display: flex;
      flex-direction: row;
      font-size: 0.75rem;
      color: ${({ theme }) => theme.colors.grayStatus};
      align-items: center;
    }
  }
`;

export const ProjectWithMockupSpan = styled.span`
  max-width: 14rem;
  font-size: 1rem;
  line-height: 2rem;
  display: block;
  width: 99%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
